import { Step } from '../components/steps/Step';
import { OnboardingFlows } from './common';

export const industry: Step = {
    id: OnboardingFlows.Industry,
    title: 'What industry does your company belong to?',
    multiSelect: false,
    randomize: true,
    skippable: true,
    options: [
        {
            label: 'Training, Education',
        },
        {
            label: 'Marketing, Advertising, Design',
        },
        {
            label: 'News, Media',
        },
        {
            label: 'Healthcare, Fitness',
        },
        {
            label: 'Technology, Software, IT',
        },
        {
            label: 'Financial services, Insurance',
        },
        {
            label: 'Consulting',
        },
        {
            label: 'Retail, eCommerce',
        },
    ],
};
